import type { ReactNode, SyntheticEvent } from "react";
import { Dialog as RadixDialog } from "radix-ui";
import { cx } from "./cx";

export interface DialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  title: ReactNode;
  children: ReactNode;
  footer: ReactNode;
  onSubmit?: () => void;
  wide?: boolean;
}

export function Dialog({ open, onOpenChange, title, children, footer, onSubmit, wide = false }: DialogProps) {
  const submit = (event: SyntheticEvent<HTMLFormElement>) => {
    event.preventDefault();
    onSubmit?.();
  };
  return (
    <RadixDialog.Root open={open} onOpenChange={onOpenChange}>
      <RadixDialog.Portal>
        <RadixDialog.Overlay className="fixed inset-0 z-scrim bg-scrim" />
        <RadixDialog.Content
          aria-describedby={undefined}
          className={cx(
            "fixed top-1/2 left-1/2 z-dialog max-h-[calc(100vh-32px)] -translate-x-1/2 -translate-y-1/2 overflow-auto rounded-2xl border border-border bg-bg px-5 py-[18px] shadow-pop",
            wide ? "w-[min(620px,calc(100vw-32px))]" : "w-[min(500px,calc(100vw-32px))]",
          )}
        >
          <form onSubmit={submit} noValidate>
            <RadixDialog.Title className="m-0 mb-2 text-xl font-semibold">{title}</RadixDialog.Title>
            {children}
            <div className="mt-4 flex justify-end gap-2">{footer}</div>
          </form>
        </RadixDialog.Content>
      </RadixDialog.Portal>
    </RadixDialog.Root>
  );
}

export function DialogText({ children }: { children: ReactNode }) {
  return <p className="m-0 mb-2 text-muted [&_b]:font-semibold [&_b]:text-fg">{children}</p>;
}

export const DialogClose = RadixDialog.Close;
